/* tslint:disable */
/* eslint-disable */
/**
 * Resource server API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import { DoctorWorkPlaceDto } from './doctor-work-place-dto';
import { UserAccountDto } from './user-account-dto';

/**
 * 
 * @export
 * @interface AppointmentDoctorDto
 */
export interface AppointmentDoctorDto {
    /**
     * 
     * @type {string}
     * @memberof AppointmentDoctorDto
     */
    'academicTitle'?: string;
    /**
     * 
     * @type {Array<DoctorWorkPlaceDto>}
     * @memberof AppointmentDoctorDto
     */
    'allWorkPlaces'?: Array<DoctorWorkPlaceDto>;
    /**
     * 
     * @type {string}
     * @memberof AppointmentDoctorDto
     */
    'bio'?: string;
    /**
     * 
     * @type {number}
     * @memberof AppointmentDoctorDto
     */
    'id'?: number;
    /**
     * 
     * @type {Set<string>}
     * @memberof AppointmentDoctorDto
     */
    'neuroscreenDiagnoses'?: Set<AppointmentDoctorDtoNeuroscreenDiagnosesEnum>;
    /**
     * 
     * @type {Array<string>}
     * @memberof AppointmentDoctorDto
     */
    'professions'?: Array<string>;
    /**
     * 
     * @type {UserAccountDto}
     * @memberof AppointmentDoctorDto
     */
    'userAccount'?: UserAccountDto;
    /**
     * 
     * @type {DoctorWorkPlaceDto}
     * @memberof AppointmentDoctorDto
     */
    'workPlace'?: DoctorWorkPlaceDto;
}

/**
    * @export
    * @enum {string}
    */
export enum AppointmentDoctorDtoNeuroscreenDiagnosesEnum {
    Headaches = 'HEADACHES',
    MovementIssues = 'MOVEMENT_ISSUES',
    MemoryIssues = 'MEMORY_ISSUES',
    EatingIssues = 'EATING_ISSUES',
    ConsciousnessIssues = 'CONSCIOUSNESS_ISSUES',
    PsychomotorDevelopmentIssues = 'PSYCHOMOTOR_DEVELOPMENT_ISSUES',
    Epilepsy = 'EPILEPSY',
    SpineIssues = 'SPINE_ISSUES',
    MutipleSclerosis = 'MUTIPLE_SCLEROSIS',
    Dizziness = 'DIZZINESS',
    Autism = 'AUTISM',
    OtherSymptoms = 'OTHER_SYMPTOMS'
}


